<div class="datatable">
    <ng-template #defaultItem let-item>
        {{ item.name }}
    </ng-template>

    <table>
        <thead>
            <tr>
                <th *ngFor="let headerItem of header()">
                    <div style="display: flex; gap: 8px; align-items: center">
                        <span>{{ headerItem.name }}</span>
                        <span class="sort-icons" *ngIf="headerItem.sortable">
                            <ai-icon
                                [fontIcon]="'fa-solid fa-angle-up fa-sm'"
                                [styleClass]="
                                    headerItem.sort == 'asc' ? 'ai-is-active' : ''
                                "
                                (click)="onClickSortColumn(headerItem, 'asc')"
                            />
                            <ai-icon
                                [fontIcon]="'fa-solid fa-angle-down fa-sm'"
                                [styleClass]="
                                    headerItem.sort == 'desc' ? 'ai-is-active' : ''
                                "
                                (click)="onClickSortColumn(headerItem, 'desc')"
                            />
                        </span>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rows()">
                <td *ngFor="let item of row">
                    <ng-container
                        *ngTemplateOutlet="
                            itemTemplate() ?? defaultItem;
                            context: { $implicit: item }
                        "
                    ></ng-container>
                </td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="100%">
                    <ng-content select="ai-table-footer"></ng-content>
                </td>
            </tr>
        </tfoot>
    </table>
</div>
